// extracted by mini-css-extract-plugin
export default {"container":"style_container__bc9K9","cards_and_history":"style_cards_and_history__d-tio","tab":"style_tab__Tb3d+","tab_item":"style_tab_item__PzmU6"};